import { v4 as uuid } from "uuid";

import * as EntityContractorPackage from "../entities/contractorPackage";
import {
  SocialCommitmentLineItem,
  createDefaultCommitments,
} from "./commitment";
import { OrganisationLineItem } from "./organisation";
import { ProjectLineItem } from "./project";
export type ContractorPackage = EntityContractorPackage.ContractorPackage;

export interface ContractorPackageLineItem {
  id: string;
  projectId: string;
  contractorId: string;
  contractorName: string;
  contractorLogo: string;
  representativeEmail: string;
  startDate: Date;
  endDate: Date;
  commitments: SocialCommitmentLineItem[];

  totalPackageValue: number;
  packageMargin: number;
  specialisedEquipmentValue: number;
  requiredSpend: number;

  deemedLabourRatio: number;
  deemedLabourHourlyRate: number;
  requiredHours: number;

  sendInvite?: boolean;
  variations: number;
  created: Date;
}

export const createDefaultContractorPackage = (
  project: ProjectLineItem,
  contractor?: OrganisationLineItem
): ContractorPackageLineItem => {
  return {
    id: uuid(),
    projectId: project.id,
    contractorId: contractor?.id || "",
    contractorName: contractor?.organisationName || "",
    contractorLogo: contractor?.organisationLogo || "",
    representativeEmail: contractor?.representativeEmail || "",
    startDate: new Date(),
    endDate: new Date(),
    commitments: createDefaultCommitments(),
    totalPackageValue: 0,
    packageMargin: 0,
    specialisedEquipmentValue: 0,
    deemedLabourRatio: 0,
    deemedLabourHourlyRate: 0,
    requiredHours: 0,
    requiredSpend: 0,
    variations: 0,
    created: new Date(),
  };
};
